// ConvertToCanon/artstyles/RomanticismStyle.js
export const applyRomanticismStyle = async (canvas, ctx, setMessage, language) => {
  // 낭만주의: 감성적이고 극적
  const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
  const data = imageData.data;
  
  // 따뜻한 색조와 부드러운 효과
  for (let i = 0; i < data.length; i += 4) {
    data[i] = Math.min(255, data[i] * 1.1 + 20); // 빨간색 강화
    data[i + 1] = Math.min(255, data[i + 1] * 1.05 + 10);
    data[i + 2] = Math.min(255, data[i + 2] * 0.95); // 파란색 약화
  }
  
  ctx.putImageData(imageData, 0, 0);
};